import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Observer } from 'rxjs';
import { PageContentService } from '../services/page-content.service';
import { AppConfig } from '../config/app-config';
import { FileSection, FileType, FileData } from '../models/fileData';

@Component({
  selector: 'app-carousel',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './carousel.component.html'
})
export class CarouselComponent implements OnInit {

  @Input() bannerImages: Array<string> = [];
  @Input() displayBanners: boolean = true;
  @Input() pageId: number;

  BannerImages$: any[] = [];

  constructor(
    config: NgbCarouselConfig,
    private pageContentService: PageContentService,
    private appConfig: AppConfig) {
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;
  }

  getBannerImages() {
    if (this.displayBanners === true) {

      this.BannerImages$ = [];

      if (this.bannerImages !== null && this.bannerImages.length > 0) {
        this.BannerImages$ = this.bannerImages;
      }
      else {
        if (this.pageId > 0) {

          this.pageContentService.getBannerImages(this.pageId).subscribe((response) => {

            response.forEach((val, idx, arr) => {
              this.buildImageUrl(this.appConfig.baseUrl + '/Uploads/PageContentBanner/Image/' + val.linkedId + '/' + val.physicalFileName);
            });

          }, (error) => {
            console.log(error);
          });
        }
      }
    }
  }

  buildImageUrl(fileLocation) {
    this.getBase64ImageFromURL(fileLocation).subscribe((res) => {
      this.BannerImages$.push('data:image/png;base64,' + res);
    });
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  ngOnChanges() {
    if (this.displayBanners === true) {
      this.getBannerImages();
    }
  }

  ngOnInit() {
  }

}
